import { DistributionSystemAdd } from '#app/routes/mocra+/_form+/components/distribution-systems/add.tsx'
import { DistributionSystemCard } from '#app/routes/mocra+/_form+/components/distribution-systems/card.tsx'
import { type DistributionSystemDraft } from '#app/routes/mocra+/_form+/components/distribution-systems/types.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type DistributionSystemListItem = {
	readonly draft: DistributionSystemDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly resources: SectionResources
	readonly systems: ReadonlyArray<DistributionSystemListItem>
	readonly onAdd: (draft: DistributionSystemDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
}

export function DistributionSystemsSection({
	resources,
	systems,
	onAdd,
	onEdit,
	onRemove,
}: Props) {
	return (
		<Section
			title="Distribution systems"
			description="Record the systems that hold distribution records so lot tracing and holds start quickly."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-3">
				{systems.length > 0 ? (
					systems.map((system, index) => {
						const errors = system.errors
						return (
							<DistributionSystemCard
								key={`distribution-system-${index}`}
								system={system.draft}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
								errors={errors.length > 0 ? [...errors] : undefined}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">
						List each downstream system that must update during a recall.
					</p>
				)}
			</div>
			<DistributionSystemAdd onSubmit={onAdd} />
		</Section>
	)
}
